import React, { useEffect, useState } from "react";
import Modal from "react-bootstrap/Modal";
import { toast } from "react-toastify";
import { useFormik } from "formik";
import MarkdownIt from "markdown-it";
import MdEditor from "react-markdown-editor-lite";

import styles from "./style.module.css";
import { CMSTypes } from "../../interfaces";
import { FAQSchema } from "../../features/cms/validations";
import { CONSTANTS } from "../../lib/constants/messages";
import { uploadFile } from "../../features/blogs/api";
import { updateFAQ, createFAQ, updateTroubleShoot, createTroubleShoot } from "../../features/cms/api";
import { addCMSCountry, updateCountryBlogs, updateCountryInsta } from "../../features/cmscountry/api";
import { useParams } from "react-router-dom";
import { CMS_TYPE } from "../../lib/constants";
import * as yup from "yup";
import { InstaSchema } from "../../features/cmscountry/validations";

interface PopupType {
  show: boolean;
  handleClose: () => void;
  getFaqs: () => void;
  faq: any | null;
  typeOfPage?:number;
  cmsId?:string;
  faqIndex?:number;
};

const CreateUpdateInsta = (props: PopupType) => {  
  const [uploadedImage, setUploadedImage] = useState<string | null>(null);
  const [imageUploading, setImageUploading] = useState(false);
  const { id } = useParams<{ id: string }>();

  const mdParser = new MarkdownIt({
    html: true,
    linkify: true,
    typographer: true,
  });
  
  

  const faqFormik = useFormik({
    initialValues:{
      url: "",
      title: "",
    },
    onSubmit: (values) => {
      const payload = {
        instaLinks:[
          {
           url: values.url,
           title: " ",
          }
        ],
        countryId: id,
        type: props.typeOfPage,
      }

      const getPayload = props.faq ? {
        instaLinkData:{
            url: values.url,
            title: " ",
          },
        
        cmsId: props.cmsId,
        instaLinkIndex: props.faqIndex,
      }:payload

      toast.promise(

            props.faq ? updateCountryInsta(getPayload) : addCMSCountry(payload),
            {
              pending: {
                render() {
                  return props.faq ? CONSTANTS.CMS.UPDATING : "Adding CMS";
                }
              },
              success: {
                render() {
                  props.getFaqs();
    
                  if (!props.faq) faqFormik.resetForm();
    
                  props.handleClose();
                  return props.faq ? CONSTANTS.CMS.SUCCESS : "Successfully Added";
                }
              },
              error: {
                render() {
                  return props.faq ? CONSTANTS.CMS.FAILED : "Failed to Add";
                }
              }
            }
          )
    
      
     
    //   const getPayload:any = props.typeOfPage === 8
    //   ? { ...values, faqId: values.faqId}
    //   : { ...values, TroubleShootId: values.TroubleShootId};
  
    //   toast.promise(

    //     props.faq ? props.typeOfPage == 8 ? updateFAQ(getPayload) : updateTroubleShoot(getPayload) : props.typeOfPage == 8 ? createFAQ(values) : createTroubleShoot(values),
    //     {
    //       pending: {
    //         render() {
    //           return props.faq ? CONSTANTS.FAQ.UPDATING : CONSTANTS.FAQ.CREATING;
    //         }
    //       },
    //       success: {
    //         render() {
    //           props.getFaqs();

    //           if (!props.faq) faqFormik.resetForm();

    //           props.handleClose();
    //           return props.faq ? CONSTANTS.FAQ.UPDATE_SUCCESS : CONSTANTS.FAQ.CREATE_SUCCESS;
    //         }
    //       },
    //       error: {
    //         render() {
    //           return props.faq ? CONSTANTS.FAQ.UPDATE_FAILED : CONSTANTS.FAQ.CREATE_FAILED;
    //         }
    //       }
    //     }
    //   )
    },
    validationSchema: InstaSchema,
  });

  const handleMainImageUpload = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (!file) return;

    setImageUploading(true);
    const formData = new FormData();
    formData.append("file", file);

    uploadFile(formData)
      .then(res => {
        const imageUrl = res.data.url;
        setUploadedImage(imageUrl);
        faqFormik.setFieldValue("featuredImage", imageUrl);
        setImageUploading(false);
        toast.success("Image uploaded successfully!");
      })
      .catch(error => {
        setImageUploading(false);
        toast.error("Failed to upload image");
        console.error("Image upload error:", error);
      });
  };

  const removeImage = () => {
    setUploadedImage(null);
    faqFormik.setFieldValue("featuredImage", "");
  };

  const handleImageUpload = (file: any, callback: any) => {
    const reader = new FileReader()
    reader.onload = () => {

      const convertBase64UrlToBlob = (urlData: any) => {
        let arr = urlData.split(","), mime = arr[0].match(/:(.*?);/)[1]
        let bstr = atob(arr[1])
        let n = bstr.length
        let u8arr = new Uint8Array(n)
        while (n--) {
          u8arr[n] = bstr.charCodeAt(n)
        }
        return new Blob([u8arr], { type: mime })
      }
      convertBase64UrlToBlob(reader.result);

      const formData = new FormData();
      formData.append("file", file);

      uploadFile(formData).then(res => {
        callback(res.data.url);
      });
    }
    reader.readAsDataURL(file)
  }

  const closePopup = () => {
    props.handleClose();
    faqFormik.resetForm();
    setUploadedImage(null);
  };

  useEffect(() => {
    if (props.faq) {
      const values:any = {
        url: props.faq.url,
      };
     
      
      faqFormik.setValues(values);
    //   setUploadedImage(props.faq.imageUrl || null);
    }
  }, [props.faq])

  return (
    <Modal size="xl" show={props.show} onHide={props.handleClose}>
      <Modal.Header className={styles.modHead}>
        <Modal.Title>{"Create Insta Link"}</Modal.Title>
      </Modal.Header>
      <Modal.Body className={styles.faqContent}>
        <div className="mb-3">
          <label className="w-100 mb-1">
            URL
            {
              faqFormik.touched.url && faqFormik.errors.url ?
                <span className="error">{faqFormik.errors.url}</span>
                :
                null
            }
          </label>
          <input
            className={styles.input}
            type="text"
            placeholder="URL"
            name="url"
            onChange={faqFormik.handleChange}
            onBlur={faqFormik.handleBlur}
            value={faqFormik.values.url}
          />
        </div>
        
      </Modal.Body>
      <Modal.Footer className={styles.modFoter}>
        <button type="button" className={styles.close} onClick={closePopup}>Close</button>
        <button type="submit" className={styles.button} onClick={faqFormik.submitForm}>Save Changes</button>
      </Modal.Footer>
    </Modal>
  );
};

export default CreateUpdateInsta;